export default {
  data: function () {
    return {
      loadingCurrentMotion: false
    }
  },
  async created () {
    await this.load()
  },
  computed: {
    motion () {
      return this.$store.getters['motions/current']
    }
  },
  methods: {
    async load () {
      this.loadingCurrentMotion = true
      await this.$store.dispatch('motions/loadCurrent')
      this.loadingCurrentMotion = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/has-current-motion.js